import axios from "axios";
import {
  getLocalStorageItem,
  localStorageConstants,
} from "../LocalStorageServices";

export function getUser() {
  return axios.get(`/User`);
}

export function updateUser(firstName: string, lastName: string) {
  return axios.put(`/User`, { firstName, lastName });
}

export function updatePin(oldPin: string, newPin: string) {
  return axios.put(`/User/pin`, {
    oldPin,
    newPin,
    refresh_token: getLocalStorageItem(localStorageConstants.refreshToken),
  });
}
